import { createTheme, responsiveFontSizes } from "@mui/material";
import { esES } from "@mui/x-data-grid/locales";

export let mainTheme = createTheme(
  {
    palette: {
      primary: {
        main: "#b22222",
        dark: "#85130b",
        light: "#eb584b",
        contrastText: "#fff",
      },
      secondary: {
        main: "#bfbfbf",
        light: "#f2f2f2",
        dark: "#8f8f8f",
        contrastText: "#000",
      },
      warning: {
        main: "#ffff66",
      },
      success: {
        main: "#009900",
      },
      error: {
        main: "#ff0000",
      },
    },

    typography: {
      fontFamily: ["Plus Jakarta Sans", "-apple-system"].join(","),
    },
  },
  esES
);

mainTheme = responsiveFontSizes(mainTheme);
